(function() {
  'use strict';

  const MOBILE_BREAKPOINT = 768;

  let toolbar = null;
  let originalTop = 0;
  let initialOriginalTop = 0;
  let ticking = false;
  let spacer = null;
  let scrollPosition = 0;
  let toolbarHeight = 0;
  let lastStickyState = null;

  function init() {
    toolbar = document.getElementById('searchspring-toolbar');
    if (!toolbar) return;

    // Create spacer to maintain space when toolbar becomes fixed
    spacer = document.createElement('div');
    spacer.className = 'searchspring-toolbar-spacer';
    toolbar.parentNode.insertBefore(spacer, toolbar.nextSibling);

    window.addEventListener('scroll', requestTick, { passive: true });
    window.addEventListener('resize', handleResize);

    // Use longer delay for mobile devices
    const delay = window.innerWidth < MOBILE_BREAKPOINT ? 1000 : 500;
    setTimeout(() => {
      updateOriginalTop();
      initialOriginalTop = originalTop;
      toolbarHeight = toolbar.offsetHeight;
      handleScroll();
    }, delay);

    waitForElement('#filter-modal', setupModalObserver);
  }

  function updateOriginalTop() {
    const rect = toolbar.getBoundingClientRect();
    originalTop = rect.top + window.pageYOffset;
  }

  function requestTick() {
    if (!ticking) {
      requestAnimationFrame(handleScroll);
      ticking = true;
    }
  }

  function handleScroll() {
    ticking = false;

    if (!toolbar || window.innerWidth >= MOBILE_BREAKPOINT) {
      toolbar?.classList.remove('is-sticky');
      if (spacer) spacer.style.height = '0px';
      lastStickyState = false;
      return;
    }

    const scrollTop = window.pageYOffset;
    const shouldBeSticky = scrollTop > initialOriginalTop + toolbarHeight;

    // Only update if state actually changed to prevent flickering
    if (shouldBeSticky !== lastStickyState) {
      lastStickyState = shouldBeSticky;

      if (shouldBeSticky) {
        // Make sticky - use pre-calculated height
        spacer.style.height = toolbarHeight + 'px';
        toolbar.classList.add('is-sticky');
      } else {
        // Remove sticky
        toolbar.classList.remove('is-sticky');
        spacer.style.height = '0px';
      }
    }
  }

  function handleResize() {
    if (!toolbar) return;

    // Recalculate dimensions on resize
    toolbarHeight = toolbar.offsetHeight;

    if (!toolbar.classList.contains('is-sticky')) {
      updateOriginalTop();
      initialOriginalTop = originalTop;
      lastStickyState = null; // Reset state
    } else if (window.innerWidth >= MOBILE_BREAKPOINT) {
      toolbar.classList.remove('is-sticky');
      spacer.style.height = '0px';
      lastStickyState = false;
    } else {
      spacer.style.height = toolbarHeight + 'px';
      lastStickyState = true;
    }
  }

  // Filter modal scroll lock - NEW CODE
  function waitForElement(selector, callback) {
    const element = document.querySelector(selector);
    if (element) return callback(element);

    const observer = new MutationObserver(() => {
      const el = document.querySelector(selector);
      if (el) {
        observer.disconnect();
        callback(el);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function setupModalObserver(filterModal) {
    new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const isOpen = filterModal.classList.contains('open');
          const wasOpen = mutation.oldValue?.includes('open');

          if (isOpen && !wasOpen) {
            scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
            Object.assign(document.body.style, {
              position: 'fixed',
              top: `-${scrollPosition}px`,
              width: '100%',
              overflow: 'hidden'
            });
          } else if (wasOpen && !isOpen) {
            Object.assign(document.body.style, { position: '', top: '', width: '', overflow: '' });
            setTimeout(() => {
              // Scroll to filter button instead of products section
              if (toolbar) {
                const header = document.querySelector('.site-header');
                const targetPosition = toolbar.offsetTop - (header?.offsetHeight || 0) - 20;
                window.scrollTo({
                  top: Math.max(0, targetPosition),
                  behavior: 'smooth'
                });
              }
            }, 100);
          }
        }
      });
    }).observe(filterModal, { attributes: true, attributeOldValue: true, attributeFilter: ['class'] });
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();